import { useLocaleStore } from "../../store/localeStore.js";
import { SUPPORTED_LOCALES } from "../../i18n/i18n.js";
import { useTranslation } from "react-i18next";

export function LocaleSwitcher(): JSX.Element {
  const { locale, setLocale } = useLocaleStore();
  const { t } = useTranslation();

  return (
    <label className="locale-switcher" title={t("language.label")}>
      <span className="sr-only">{t("language.label")}</span>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value as typeof locale)}
        className="switcher-select"
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
